
import React from 'react';

import NonFSIndex from "@dndComponents/NonFSIndex";

export default function ResourceIndex() {
  return (
    <NonFSIndex
      data_type="resource"
    />
  );
}
